import axios from "axios";
const BASIC_API_URL = "/api";

/*interface UserResponse {
  status: number;
  message?: string;
  user?: User;
}*/

export const newHeadset = async (headsetData) => {
  console.log(headsetData);
  try {
    const response = await axios.post(
      `${BASIC_API_URL}/headset/newHeadset`,
      headsetData
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'headset :", error);
    throw new Error("Erreur lors de l'ajout de l'headset");
  }
};

/*export const getGroupeByCompID = async (compID) => {
  try {
    const response = await axios.get(`${BASIC_API_URL}/group/byComp/${compID}`);
    return response;
  } catch (error) {
    console.log(compID);
    throw new Error(`${error.response.data.error}`);
  }
};
*/